import { createReducer, createActions } from 'reduxsauce';
import get from 'lodash-es/get';

const EMPTY_PROPERTY_INFO = {
  addons: {
    'fridge-clean': 0,
    'laundry-clean': 0,
    'mopping-clean': 0,
    'oven-clean': 0,
    'window-clean': 0
  },
  isActive: true,
  isKeyReleaseSigned: false,
  serviceTypes: { 'hotel-style': 6900, 'deep-clean': 0, 'move-out': 0 }
};

const { Types, Creators } = createActions({
  startup: null,
  setAppDataLoadRequest: ['isFrom'],
  setAppDataUpdatePropertyInfo: ['propertyId', 'data'],
  setPriceDataLoadRequest: null,
  setLoading: ['loading'],
  setLoaded: ['loaded'],
  setAppData: ['data'],
  setShowMoveOutModal: ['showMoveOutModal']
});

export const LOGIN_PAGES = {
  LOG_IN: 'login',
  SIGN_UP: 'signup',
  RESET: 'reset'
};

export const AppTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  loading: false,
  loaded: false,
  data: {},
  showMoveOutModal: false
};

/* ------- Selectors --------- */
export const AppSelectors = {
  selectLoading: state => state.app.loading,
  selectLoaded: state => state.app.loaded,
  selectAppData: state => state.app.data,
  selectFrequencyData: state => state.app.data.frequencies,
  selectPropertyInfoOf: (state, property) => {
    if (!property || !property.propertyID) {
      return EMPTY_PROPERTY_INFO;
    }
    return get(
      state,
      `app.data.properties.${property.propertyID}`,
      EMPTY_PROPERTY_INFO
    );
  },
  selectIsKeyReleaseSignedOf: (state, property) => {
    if (!property || !property.propertyID) {
      return false;
    }
    return get(
      state,
      `app.data.properties.${property.propertyID}.isKeyReleaseSigned`,
      false
    );
  },
  selectServiceTypeData: state => state.app.data.serviceTypes,
  selectAddonData: state => state.app.data.addons,
  selectShowMoveOutModal: state => state.app.showMoveOutModal
};

/* -------- Reducers ---------- */
export const setLoading = (state, { loading }) => ({
  ...state,
  loading
});

export const setLoaded = (state, { loaded }) => ({
  ...state,
  loaded
});

export const setAppData = (state, { data }) => ({
  ...state,
  data: {
    ...state.data,
    ...data
  }
});
export const setUserProfileData = (state, { userProfileData }) => ({
  ...state,
  userProfileData: {
    ...state.userProfileData,
    ...userProfileData
  }
});

export const setShowMoveOutModal = (state, { showMoveOutModal }) => ({
  ...state,
  showMoveOutModal
});

export const setAppDataUpdatePropertyInfo = (state, { propertyId, data }) => {
  const existingProperty = get(state, `data.properties.${propertyId}`, {});

  return {
    ...state,
    data: {
      ...state.data,
      properties: {
        ...state.data.properties,
        [propertyId]: {
          ...existingProperty,
          ...data
        }
      }
    }
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_LOADING]: setLoading,
  [Types.SET_LOADED]: setLoaded,
  [Types.SET_APP_DATA]: setAppData,
  [Types.SET_APP_DATA_UPDATE_PROPERTY_INFO]: setAppDataUpdatePropertyInfo,
  [Types.SET_SHOW_MOVE_OUT_MODAL]: setShowMoveOutModal
});
